import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import brLocale from "date-fns/locale/pt-BR";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TextField as MuiTextField } from "@mui/material";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import MuiTooltip from "@material-ui/core/Tooltip";
import DateRangeIcon from "@material-ui/icons/DateRange";
import api from "../../services/api";
import { format } from "date-fns";
import { toast } from "sonner";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const getLastDayOfMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

const getFirstDayOfMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), 1);
};

export const ChartsUser = () => {
  const [initialDate, setInitialDate] = useState(
    getFirstDayOfMonth(new Date())
  );
  const [finalDate, setFinalDate] = useState(getLastDayOfMonth(new Date()));
  const [ticketsData, setTicketsData] = useState({ data: [] });
  const [dateAnchor, setDateAnchor] = useState(null);

  useEffect(() => {
    handleGetTicketsInformation();
  }, [initialDate, finalDate]);

  const handleGetTicketsInformation = async () => {
    try {
      const { data } = await api.get(
        `/dashboard/ticketsUsers?initialDate=${format(
          initialDate,
          "yyyy-MM-dd"
        )}&finalDate=${format(finalDate, "yyyy-MM-dd")}`
      );
      setTicketsData(data);
    } catch (error) {
      toast.error("Erro ao buscar informações dos tickets");
    }
  };

  const chartColors = [
    "#35af9a", "#3B82F6", "#8B5CF6", "#F59E0B", "#EF4444",
    "#06B6D4", "#10B981", "#EC4899", "#F97316", "#6366F1",
    "#14B8A6", "#A855F7", "#84CC16", "#0EA5E9", "#E11D48",
  ];

  const dataCharts = {
    labels:
      ticketsData?.data?.length > 0
        ? ticketsData.data.map((item) => item.nome)
        : [],
    datasets: [
      {
        label: "Atendimentos",
        data:
          ticketsData?.data.length > 0
            ? ticketsData.data.map((item) => item.quantidade)
            : [],
        backgroundColor: chartColors,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutout: "60%",
    animation: {
      duration: 1200,
      easing: "easeInOutQuart",
    },
    plugins: {
      datalabels: {
        color: "#FFFFFF",
        font: { family: "Inter", weight: "bold", size: 11 },
        formatter: (value) => (value > 0 ? value : ""),
      },
      legend: {
        position: "top",
        labels: {
          boxWidth: 10,
          boxHeight: 10,
          padding: 10,
          font: { family: "Inter", size: 11 },
        },
      },
    },
  };

  return (
    <>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 8,
        }}
      >
        <Typography
          component="h2"
          variant="h6"
          style={{
            fontFamily: '"Inter", "Poppins", sans-serif',
            fontWeight: 700,
            fontSize: 15,
            color: "#1E293B",
          }}
        >
          Total de atendimentos por usuário
        </Typography>

        <MuiTooltip title="Período">
          <IconButton
            size="small"
            onClick={(e) => setDateAnchor(e.currentTarget)}
            style={{
              borderRadius: 8,
              backgroundColor: "#F1F5F9",
              width: 32,
              height: 32,
            }}
          >
            <DateRangeIcon style={{ fontSize: 18, color: "#64748B" }} />
          </IconButton>
        </MuiTooltip>
      </Box>

      <Popover
        open={Boolean(dateAnchor)}
        anchorEl={dateAnchor}
        onClose={() => setDateAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          style: {
            padding: 16,
            display: "flex",
            flexDirection: "column",
            gap: 12,
            borderRadius: 12,
            minWidth: 240,
          },
        }}
      >
        <Typography
          style={{
            fontFamily: '"Inter", "Poppins", sans-serif',
            fontSize: 13,
            fontWeight: 600,
            color: "#1E293B",
            marginBottom: 4,
          }}
        >
          Período
        </Typography>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={brLocale}
        >
          <DatePicker
            value={initialDate}
            onChange={(newValue) => setInitialDate(newValue)}
            label="Data inicial"
            renderInput={(params) => (
              <MuiTextField fullWidth {...params} size="small" />
            )}
          />
        </LocalizationProvider>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={brLocale}
        >
          <DatePicker
            value={finalDate}
            onChange={(newValue) => setFinalDate(newValue)}
            label="Data final"
            renderInput={(params) => (
              <MuiTextField fullWidth {...params} size="small" />
            )}
          />
        </LocalizationProvider>
      </Popover>

      <div style={{ maxHeight: 260, display: "flex", justifyContent: "center" }}>
        <Doughnut
          options={options}
          data={dataCharts}
          plugins={[ChartDataLabels]}
          style={{ maxWidth: "100%", maxHeight: "260px" }}
        />
      </div>
    </>
  );
};
